class Flipbox {
  constructor() {
    this.boxes = Array.prototype.slice.call(document.querySelectorAll('.lc-flipbox'));

    if (this.boxes.length) {
      this.boxes.forEach((box) => this.init(box));
    }
  }

  init(box) {
    this.markMobileBack(box);

    const toggles = Array.prototype.slice.call(box.querySelectorAll('[data-flipbox-toggle]'));
    toggles.forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggle(box);
      });
    });
  }

  markMobileBack(box) {
    const mobileBack = box.querySelector('.lc-flipbox__img--back-mobile');
    if (!mobileBack || !this.hasUsableSrc(mobileBack)) {
      return;
    }

    box.classList.add('has-mobile-back');
  }

  hasUsableSrc(img) {
    const candidates = [
      img.getAttribute('src'),
      img.getAttribute('data-src'),
      img.currentSrc,
    ];

    return candidates.some((value) => {
      if (!value) {
        return false;
      }

      const src = String(value).trim();
      if (!src || src === '#' || src.startsWith('data:image/svg')) {
        return false;
      }

      // Empty Livingdocs placeholders often keep a 1x1 or blank name
      if (/placeholder|spacer|blank/i.test(src)) {
        return false;
      }

      return true;
    });
  }

  toggle(box) {
    const isFlipped = box.classList.toggle('is-flipped');
    box.setAttribute('aria-pressed', isFlipped ? 'true' : 'false');
  }
}

export default Flipbox;
